// extracted by mini-css-extract-plugin
export default {"mobilekorraLogo":"mobilekorraLogo__MrKJ5","korraLogoBranded":"korraLogoBranded__TvuhK","desktopkorraLogo":"desktopkorraLogo__4T1rs","widgetkorraLogo":"widgetkorraLogo__9I4qH"};